angular.module('core')
  .service('districtApi', ['authentication', '$state', 'highlightsApi', 'cancelableResourceFactory', 'cancelableResourceManager', 'timeframe', function ($authentication, $state, $highlightsApi, $cancelableResourceFactory, $cancelableResourceManager, $timeframe) {
    var self = this;

    var districtSettingsMapping = function(body) {
      try {
        var district = JSON.parse(body);
        district.type = 'district';
        district.admins = district.admins || [];
        return district;
      }
      catch(e) {
        console.error('Transform Error:', e.message);
        return {};
      }
    };

    var DistrictSettings = $cancelableResourceFactory.createCacheableResource(null, '/m/district/:id/settings', {
      id: '@id'
    }, {
      get: {
        transformResponse: districtSettingsMapping,
        url: '/m/district/:id/settings',
        method: 'GET'
      }
    });

    /**************************************************************/
    /*                          Api                               */
    /**************************************************************/

    self.getDistrict = function(callback) {
      var item = {
        name: $authentication.getCustomer().district_name,
        id: $authentication.getCustomer().district_id,
        type: 'district',
        provision_uid: -1
      };

      callback(item);
    };

    // deprecated: use getDistrictHighlights
    self.getDistrictData = function(callback) {
      var params = _.pick($state.params, ['districtId']);
      params.sy = $timeframe.calculateCurrentReportingYear();
      var promises = $highlightsApi.DistrictHighlights.get(params);

      promises.$promise.then(callback);
      return promises;
    };

    self.getDistrictHighlights = function(params) {
      return $highlightsApi.DistrictHighlights.get(params).$promise;
    };

    /**************************************************************/
    /*                      Settings Api                          */
    /**************************************************************/

    self.getDistrictSettings = function(did, success, error) {
      var districtSettings = DistrictSettings.get({id: did});
      districtSettings.$promise.then(function(district) {
        district.type = 'district';
        success(district);
      });
      return districtSettings;
    };

    self.saveDistrictSettings = function(item, success, error) {
      var district = new DistrictSettings(item);
      district.$save([], success, error);
    };

  }]);
